var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67465 11.3332C6.48789 11.3332 6.31047 11.2588 6.17974 11.1285L3.53709 8.49629C3.26628 8.22656 3.26628 7.7801 3.53709 7.51036C3.80789 7.24062 4.25611 7.24062 4.52691 7.51036L6.67465 9.64965L11.4744 4.86881C11.7452 4.59907 12.1934 4.59907 12.4642 4.86881C12.735 5.13854 12.735 5.585 12.4642 5.85474L7.16957 11.1285C7.03884 11.2588 6.86141 11.3332 6.67465 11.3332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9c076fe3.svg";
export { ForwardRef as ReactComponent };